import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env } from "../env";

let client: SupabaseClient | null = null;

/** The panel's Supabase client: the same project as the plugin (firm-model spec §5.1).
 * Supabase is auth only here too; data goes through the SlideBrain API. The implicit flow
 * lets OAuth and invite links land their session in the URL hash on any route. */
export function getSupabase(): SupabaseClient {
  if (!client) {
    if (!env.supabaseUrl || !env.supabaseAnonKey) throw new Error("Supabase is not configured in this build");
    client = createClient(env.supabaseUrl, env.supabaseAnonKey, {
      auth: { detectSessionInUrl: true, persistSession: true, autoRefreshToken: true, flowType: "implicit" },
    });
  }
  return client;
}
